import type { TrailerBodyStyle, TrailerHitch, TruckBodyStyle, TruckCoupling } from '../validation/fleet.schemas';

/**
 * Whether a truck of a class can pull a trailer of a type (gitaumoses4/chukua#390): the one rule the coupling write, dispatch's
 * job-fit check and the web's trailer picker all apply, so they never disagree.
 */
export function couplingFitsHitch(coupling: TruckCoupling, hitch: TrailerHitch): boolean {
  if (coupling === 'fifth_wheel') return hitch === 'kingpin';
  if (coupling === 'drawbar_hitch') return hitch === 'drawbar';
  return false;
}

/** What a new class of this body style tows unless an admin says otherwise: a tractor has a fifth wheel; a tipper or dropside may pull a drawbar trailer. */
export function defaultTruckCoupling(bodyStyle: TruckBodyStyle): TruckCoupling {
  if (bodyStyle === 'tractor') return 'fifth_wheel';
  if (bodyStyle === 'tipper' || bodyStyle === 'dropside') return 'drawbar_hitch';
  return 'none';
}

/** A drawbar trailer has its own front axle and a bar; every other trailer body is a semi-trailer on a kingpin. */
export function defaultTrailerHitch(bodyStyle: TrailerBodyStyle): TrailerHitch {
  return bodyStyle === 'drawbar' ? 'drawbar' : 'kingpin';
}
